import { render, staticRenderFns } from "./CreateTemplatePopup.vue?vue&type=template&id=0ed8e87d&scoped=true"
import script from "./CreateTemplatePopup.vue?vue&type=script&lang=js"
export * from "./CreateTemplatePopup.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplatePopup.vue?vue&type=style&index=0&id=0ed8e87d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed8e87d",
  null
  
)

export default component.exports